import React from "react"
import theme from "../../../config/theme";

const Title = (props) => (
    <div className="title-wrapper">
        <style jsx>{`
            .title-wrapper {
                ${props.padded ? 'padding-left: 20px;' : ''}
                background-color: transparent; 
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                ${props.margin ? `margin-top: 10px` : ``};
                width: 100%;
                box-sizing: border-box;
                margin-bottom: ${props.marginBottom ? props.marginBottom +'px;': ';'}
            }

            h1 {
                font-size: ${theme.font.title};
                color: ${props.color || theme.colors.typography.title};
                text-transform: uppercase;
                width: 100%;
                display: flex;
            
                align-items: center;
                justify-content: ${props.align ? props.align : "center"};

            }

            h2 {
                font-size: ${theme.font.subtitle};
                color: ${props.color || theme.colors.base.darkGray};
                text-transform: uppercase;
            }

        `}</style>
        {   props.variant === 'title' ? 
                <h1>{props.children}</h1> :
            props.variant === 'subtitle' ?
                <h2>{props.children}</h2> : 
                <div>{props.children}</div>
        }
    </div>
)

export default Title;